import {Component, Input} from '@angular/core';
import {EChartsOption} from 'echarts';

@Component({
    selector: 'dmp-chart',
    templateUrl: './dmp-chart.component.html',
    styleUrls: ['./dmp-chart.component.scss'],
    standalone: false
})
export class DmpChartComponent {
    @Input() options: EChartsOption;
    @Input() height = 300;
}
